import Image from 'next/image';
import Link from 'next/link';

interface IDownloads {
  downloads: {
    name: string;
    icon: {
      sourceUrl: string;
    };
    file: {
      mediaItemUrl?: string;
    };
  }[];
}

export const Downloads2 = ({ downloads }: IDownloads) => {
  return (
    <div className="flex flex-row flex-wrap my-4">
      {downloads?.map((download) => {
        const link = download.file.mediaItemUrl?.replace(
          'https://kns.you2.pl/wp-content',
          ''
        );
        return (
          <div className="flex flex-col w-32 mx-2">
            <div className="w-full">
              <Link href={`${link}`} target="_blank" rel="noopener">
                <Image
                  src={
                    download.icon?.sourceUrl
                      ? download.icon?.sourceUrl
                      : '/img/assets/download.png'
                  }
                  width={120}
                  height={120}
                  alt={download.name}
                  className="mx-auto"
                />
              </Link>
            </div>
            <div className="my-auto text-sm text-center hover:underline">
              <a href={`${link}`} target="_blank">
                {download.name}
              </a>
            </div>
          </div>
        );
      })}
    </div>
  );
};
